<template>
    <div class="field-container dates" :class="class_width">
        <template v-if="config.merge">
            <label for="booking_cms_input_dates" :style="getStylesLabel">{{ getLabel.label }}</label>
            <input  id="booking_cms_input_dates" :style="getStylesInput" :value="getDates" type="text">
        </template>

        <template v-else>
            <div class="field-date" >
                <label for="booking_cms_input_arrive" :style="getStylesLabel">{{ getLabel.label_arrive }}</label>
                <input id="booking_cms_input_arrive" :style="getStylesInput" :value="getDates.date_arrive" @change="changeStartDate($event.target.value)" type="text">
            </div>
            <div class="field-date">
                <label for="booking_cms_input_departure" :style="getStylesLabel">{{ getLabel.label_departure }}</label>
                <input id="booking_cms_input_departure" :style="getStylesInput" :value="getDates.date_departure" @change="changeEndDate($event.target.value)" type="text">
            </div>
        </template>
        
    </div>
</template>

<script>

import SymphonyBooking from '../lib/SymphonyBooking'

    export default{
        name: 'BookingInputDate',
        props:{
            attributes: Object,
            config: Object,
            icon: String,
            startDate: String,
            endDate: String,
            class_width:String
        },
        computed: {
            getStylesLabel(){
                const  { border , padding , fontSizeLabel , fontSizeLabelInside , fontSize , backgroundColor , ...rest  } = this.attributes
                 const paddings = padding.split(' ')
                 
                if( this.attributes['label-inside'] ){
                    return {
                        ...rest,
                        position: 'absolute',
                        fontSize: fontSizeLabel,
                        transition: 'all 0.2s ease',
                        top: paddings[0],
                        left: paddings[3],
                        pointerEvents: 'none',
                    }
                }else{
                    return { 
                        ...rest,
                        fontSize: fontSizeLabel
                    }
                }
            },
            getStylesInput(){
                const {  border , lineHeight , ...rest } = this.attributes
                return{
                    borderTop: border.top,
                    borderBottom: border.bottom,
                    borderRight: border.right,
                    borderLeft: border.left,
                    ...rest,
                    backgroundImage: `url(${this.icon})`,
                    backgroundSize: 'auto 16px',
                    backgroundPositionY: 'center',
                    backgroundPositionX: 'calc(100% - 15px)',
                }
            },
            getDates(){
                let configFormat = this.config.format
                if( configFormat == null ){
                    configFormat = "MM/DD/YYYY"
                }
                if(this.startDate !== '' && !this.firstValueNotEmpty && this.attributes['label-inside']){
                    document.querySelectorAll('.field-container.dates input').forEach((input , index) =>{
                        input.previousElementSibling.style.fontSize = this.attributes.fontSizeLabelInside
                        input.previousElementSibling.style.top = '4px'
                    })
                    this.firstValueNotEmpty = true
                }
                if( this.config.merge ){
                    let dateString = SymphonyBooking.parseDate({date: this.startDate,format: configFormat})
                    if(this.endDate !== '' && !this.attributes['label-inside'] ){
                        dateString += '  -  ' + SymphonyBooking.parseDate({date: this.endDate,format: configFormat})
                    }else{
                        let dateStringInside = `${SymphonyBooking.parseDate({date: this.startDate,format: configFormat}) }  -  ${SymphonyBooking.parseDate({date: this.endDate,format: configFormat})}`
                        dateString = this.endDate == '' && this.startDate == '' ? '' : dateStringInside
                    }
                    return dateString
                }else{
                    if(this.attributes['label-inside'] ){
                        return{
                            date_arrive: this.startDate == '' ? '' : SymphonyBooking.parseDate({date: this.startDate,format: configFormat}),
                            date_departure: this.endDate == '' ? '' : SymphonyBooking.parseDate({date: this.endDate,format: configFormat})
                        }
                    }else{
                        return{
                            date_arrive: SymphonyBooking.parseDate({date: this.startDate,format: configFormat}),
                            date_departure: SymphonyBooking.parseDate({date: this.endDate,format: configFormat})
                        }
                    }
                }
               
            },

            getLabel(){

                if( this.config.merge ){
                    return {
                        label : this.config.label
                    }
                }

                let labels = this.config.label.split('/')

                return{
                    label_arrive: labels[0],
                    label_departure: labels[1]
                }

            }

        },
        watch:{
            startDate: function(){
                this.$parent.$parent.$emit('update-data' , {
                    checkin : this.startDate
                })
            },
            endDate: function(){
                this.$parent.$parent.$emit('update-data' , {
                    checkout : this.endDate
                })
            }
        },
        methods:{
            changeStartDate(value){
                this.$parent.$parent.$emit('update-data' , {
                    checkin : this.dateFormat(value)
                })
            },
            changeEndDate(value){
                this.$parent.$parent.$emit('update-data' , {
                    checkout : this.dateFormat(value)
                })
            },
            dateFormat(date){
                const [month, day, year] = date.split('/');
                return `${day}-${month}-${year}`;
            }
        },
        data(){
            return{
                firstValueNotEmpty: false
            }
        },
        mounted(){
            SymphonyBooking.getRangeDates( this.config.minDate )
        }
    }

</script>

<style lang="scss">
    .field-date{
        position: relative;
        &:last-child{
            margin-top: 20px;
        }
    }
</style>